/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Fuel_TypeInputs */

const en_field_fuel_type = /** @type {(inputs: Field_Fuel_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuel Type`)
};

const es_field_fuel_type = /** @type {(inputs: Field_Fuel_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de combustible`)
};

const fr_field_fuel_type = /** @type {(inputs: Field_Fuel_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de carburant`)
};

const de_field_fuel_type = /** @type {(inputs: Field_Fuel_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraftstoffart`)
};

const ja_field_fuel_type = /** @type {(inputs: Field_Fuel_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`燃料タイプ`)
};

const zh_field_fuel_type = /** @type {(inputs: Field_Fuel_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`燃料类型`)
};

const ar_field_fuel_type = /** @type {(inputs: Field_Fuel_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع الوقود`)
};

const id_field_fuel_type = /** @type {(inputs: Field_Fuel_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Bahan Bakar`)
};

const it_field_fuel_type = /** @type {(inputs: Field_Fuel_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di Carburante`)
};

const ru_field_fuel_type = /** @type {(inputs: Field_Fuel_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип топлива`)
};

const pt_field_fuel_type = /** @type {(inputs: Field_Fuel_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de Combustível`)
};

const ko_field_fuel_type = /** @type {(inputs: Field_Fuel_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연료 종류`)
};

/**
* | output |
* | --- |
* | "Fuel Type" |
*
* @param {Field_Fuel_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_fuel_type = /** @type {((inputs?: Field_Fuel_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Fuel_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_fuel_type(inputs)
	if (locale === "es") return es_field_fuel_type(inputs)
	if (locale === "fr") return fr_field_fuel_type(inputs)
	if (locale === "de") return de_field_fuel_type(inputs)
	if (locale === "ja") return ja_field_fuel_type(inputs)
	if (locale === "zh") return zh_field_fuel_type(inputs)
	if (locale === "ar") return ar_field_fuel_type(inputs)
	if (locale === "id") return id_field_fuel_type(inputs)
	if (locale === "it") return it_field_fuel_type(inputs)
	if (locale === "ru") return ru_field_fuel_type(inputs)
	if (locale === "pt") return pt_field_fuel_type(inputs)
	return ko_field_fuel_type(inputs)
});